import http from 'utils/http';

export const fetchDetailMerchantReport = ({ merchantId, query, page }) => http.get(`v1/organizations/{{organizationId}}/reporting/merchants/${merchantId}/?page=${page}&${query}`).then((res) => res.data);
